module.exports = "/_next/static/images/multibit-30182d65de48baf660675fde7733ac19.png";